export default "/images/vendor/flag-icon-css/flags/1x1/ta.svg?6569311e37bb6e9563154bd736dfb823";